import { createFileRoute } from "@tanstack/react-router"
import { Link as LinkRouter } from "@tanstack/react-router"
import { Button, Container, Heading, Link, List, Text } from "@chakra-ui/react"
import * as CookieConsent from "vanilla-cookieconsent"

export const Route = createFileRoute("/datenschutz")({
  component: PrivacyPolicy,
})


function PrivacyPolicy() {
  return (
    <Container w="80%" mt={20} mb={20}>
      <Button asChild variant="primary" mb={8}><LinkRouter to="/">Zurück</LinkRouter></Button>

      <Heading size="4xl" color="main" mb={8}>
        Datenschutzerklärung
      </Heading>
      <Text mb={8}>
        Verantwortliche Stelle im Sinne der Datenschutzgesetze, insbesondere der
        EU-Datenschutzgrundverordnung (DSGVO), ist:
      </Text>
      <Text mb={2}>Herrmann AG</Text>
      <Text>
        Telefon: <Link href="tel:+41 34 409 40 00" color="main">034 409 40 00</Link>
      </Text>
      <Text mb={8}>
        E-Mail:{" "}
        <Link href="mailto:info@herrmann-druck.ch" color="main">info@herrmann-druck.ch</Link>
      </Text>
      <Button mb={8} variant="primary" onClick={() => CookieConsent.showPreferences()}>
        Cookie Einstellungen
      </Button>

      <Heading size="lg" color="main" mb={2}>
        Allgemeiner Hinweis
      </Heading>
      <Text mb={4}>
        Gestützt auf Artikel 13 der schweizerischen Bundesverfassung und den
        datenschutzrechtlichen Bestimmungen des Bundes (Datenschutzgesetz, DSG)
        hat jede Person Anspruch auf Schutz ihrer Privatsphäre sowie auf Schutz
        vor Missbrauch ihrer persönlichen Daten. Die Betreiber dieser Seiten
        nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln
        Ihre personenbezogenen Daten vertraulich und entsprechend der
        gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
      </Text>
      <Text mb={4}>
        In Zusammenarbeit mit unseren Hosting-Providern bemühen wir uns, die
        Datenbanken so gut wie möglich vor fremden Zugriffen, Verlusten,
        Missbrauch oder vor Fälschung zu schützen.
      </Text>
      <Text mb={4}>
        Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei
        der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
        lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
        möglich.
      </Text>
      <Text mb={8}>
        Durch die Nutzung dieser Website erklären Sie sich mit der Erhebung,
        Verarbeitung und Nutzung von Daten gemäss der nachfolgenden Beschreibung
        einverstanden.
      </Text>

      <Heading size="lg" color="main" mb={2}>
        Datenschutzerklärung für Cookies
      </Heading>
      <Text mb={4}>
        Diese Website verwendet Cookies. Cookies sind Textdateien, die Daten von
        besuchten Websites oder Domains enthalten und von einem Browser auf dem
        Computer des Benutzers gespeichert werden. Ein Cookie dient in erster
        Linie dazu, die Informationen über einen Benutzer während oder nach
        seinem Besuch innerhalb eines Onlineangebotes zu speichern. Zu dem
        Begriff der Cookies zählen wir ferner andere Technologien, die die
        gleichen Funktionen wie Cookies erfüllen (z.B., wenn Angaben der Nutzer
        anhand pseudonymer Onlinekennzeichnungen gespeichert werden, auch als
        "Nutzer-IDs" bezeichnet)
      </Text>
      <Text mb={8}>
        Die meisten Internet-Browser akzeptieren Cookies automatisch. Sie können
        Ihren Browser jedoch so konfigurieren, dass keine Cookies auf Ihrem
        Computer gespeichert werden oder stets ein Hinweis erscheint, wenn Sie
        ein neues Cookie erhalten. Die Deaktivierung von Cookies kann dazu
        führen, dass Sie nicht alle Funktionen unserer Website nutzen können.
      </Text>

      <Heading size="lg" color="main" mb={2}>
        Datenschutzerklärung für SSL-/TLS-Verschlüsselung
      </Heading>
      <Text mb={4}>
        Diese Website nutzt aus Gründen der Sicherheit und zum Schutz der
        Übertragung vertraulicher Inhalte, wie zum Beispiel der Anfragen, die
        Sie an uns als Seitenbetreiber senden, eine SSL-/TLS-Verschlüsselung.
        Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile
        des Browsers von "http://" auf "https://" wechselt und an dem
        Schloss-Symbol in Ihrer Browserzeile.
      </Text>
      <Text mb={8}>
        Wenn die SSL bzw. TLS-Verschlüsselung aktiviert ist, können die Daten,
        die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
      </Text>

      <Heading size="lg" color="main" mb={2}>
        Datenschutzerklärung für Server-Log-Files
      </Heading>
      <Text mb={4}>
        Der Provider dieser Website erhebt und speichert automatisch
        Informationen in so genannten Server-Log Files, die Ihr Browser
        automatisch an uns übermittelt. Dies sind:
      </Text>
      <List.Root mb={4}>
        <List.Item>Browsertyp und Browserversion</List.Item>
        <List.Item>verwendetes Betriebssystem</List.Item>
        <List.Item>Referrer URL</List.Item>
        <List.Item>Hostname des zugreifenden Rechners</List.Item>
        <List.Item>Uhrzeit der Serveranfrage</List.Item>
      </List.Root>
      <Text mb={8}>
        Diese Daten sind nicht bestimmten Personen zuordenbar. Eine
        Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
        vorgenommen. Wir behalten uns vor, diese Daten nachträglich zu prüfen,
        wenn uns konkrete Anhaltspunkte für eine rechtswidrige Nutzung bekannt
        werden.
      </Text>

      <Heading size="lg" color="main" mb={2}>
        Änderungen
      </Heading>
      <Text mb={4}>
        Wir können diese Datenschutzerklärung jederzeit ohne Vorankündigung
        anpassen. Es gilt die jeweils aktuelle, auf unserer Website publizierte
        Fassung.
      </Text>
      <Text>Letzte Änderung 13.11.2025</Text>
    </Container>
  )
}
